import { useContext, useEffect, useState } from 'react';
import { AlertBox } from './components/common/AlertBox';
import FullLoader from './components/common/FullLoader';
import { AppContext } from './context/AppProvider';
import AppRoutes from './routes';


import { handleChainLitChatBot } from './services/user';
import ChainlitBot from './components/common/player/ChainlitBot';
import { useLocation} from 'react-router-dom';
import { toBeExcluded } from './assets/constants/constants';
import { appCuesIdentify } from './lib/appcues';
import useRouteChangeHandler from './hooks/useRouteChangeHandler';


function App() {

  const { state } = useContext(AppContext);
  const userId = state?.user?.userId;
  const [token, setToken] = useState<any>(null);
  const location = useLocation();
  const {handleRedirection}=useRouteChangeHandler()
  const isLoginOrSignup = toBeExcluded.includes(location.pathname);
  useEffect(() => {
    const fethChainlitToken = async () => {
      if (state?.user?.userId) {
        const response = await handleChainLitChatBot();
        setToken(response?.data);
      } else {
        setToken(null)
      }
    }
    if (state?.user?.userId && !isLoginOrSignup) {
      fethChainlitToken()
    } else {
      setToken(null)
    }
  }, [state?.user?.userId, isLoginOrSignup])

  useEffect(() => {
    if (!toBeExcluded.includes(window.location.pathname)){
        appCuesIdentify({
          userId:state?.user?.email,
          user_name:state?.user?.name,
          event_timestamp:new Date()
        })
    }
  }, [window.location.pathname,state?.user?.email])
  useEffect(()=>{
    handleRedirection()
  },[location.pathname])
  return (
    <div className="flex flex-col h-[calc(100vh-5rem)]">
      <FullLoader loading={state.loading} />
      <AppRoutes />
      <AlertBox />
      {(!isLoginOrSignup && token) && (
        <ChainlitBot userId={userId} token={token} />
      )}
    </div>
  );
}

export default App;
